import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslatedField } from '../models';
import { getTranslatedText } from '../utils/translation.util';

@Pipe({
    name: 'translateValue',
    standalone: true
})
export class TranslateValuePipe implements PipeTransform {
    constructor(public translateService: TranslateService){}

    transform(value: TranslatedField[]): string {
        return getTranslatedText(value, this.translateService.currentLang);
    }

}
